export const selectValues={
  1: 'Admin',
  2: 'User'
}